import axios from 'axios'

export const getPlaces = (partnerId: string) => {
  return axios
    .get('/data/sadarbības_partnera_vieta?sadarbības_partneris_id=' + partnerId)
    .then((resp) => resp.data)
}
